import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { NdkStorageModule } from '@ndk/ng-storage';

import { SharedModule } from '../../shared/shared.module';
import { CORE_CONFIG } from '../core.config';
import { AuthGuardService } from './auth-guard.service';
import { AuthInterceptor } from './auth-interceptor';
import { AuthProfileService } from './auth-profile.service';
import { AuthTokenService } from './auth-token.service';
import { AuthService } from './auth.service';

@NgModule({
    imports: [
        SharedModule,
        RouterModule,
        NdkStorageModule,
    ],
    exports: [],
    declarations: [],
    providers: [
        { provide: CORE_CONFIG_TOKEN, useValue: CORE_CONFIG },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        AuthProfileService,
        AuthTokenService,
        AuthService,
        AuthGuardService,
    ],
})
export class AuthModule { }
